// 납입지시 - ERP_OEM 출하관리
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const ROM3H = lazy(() => import('@/pages/A02/ROM3H'));  // 납품서발행(VMI)
const ROM3L = lazy(() => import('@/pages/A02/ROM3L'));  // 납품서발행(PO)
const ROM3J = lazy(() => import('@/pages/A02/ROM3J'));  // 발행취소/재인쇄
const ROM4H = lazy(() => import('@/pages/A02/ROM4H'));  // 부품식별표(VMI)
const ROM4N = lazy(() => import('@/pages/A02/ROM4N'));  // 부품식별표(PO)
const ROM4P = lazy(() => import('@/pages/A02/ROM4P'));  // 출하정보전송
const ROM4V = lazy(() => import('@/pages/A02/ROM4V'));  // 부품식별표(KIA 2D)
const ROM3T = lazy(() => import('@/pages/A02/ROM3T'));  // 납품서삭제내역
const ROM3V = lazy(() => import('@/pages/A02/ROM3V'));  // 백지카드 발행
// const REX3H = lazy(() => import('@/pages/A02/REX3H')); // 납품서 일괄발행(VMI)
const REX3I = lazy(() => import('@/pages/A02/REX3I'));  // 납품서 일괄발행(VMI)

function A02() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/A02/ROM3H" component={ROM3H} />
        <Route path="/A02/ROM3L" component={ROM3L} />
        <Route path="/A02/ROM3J" component={ROM3J} />
        <Route path="/A02/ROM4H" component={ROM4H} />
        <Route path="/A02/ROM4N" component={ROM4N} />
        <Route path="/A02/ROM4V" component={ROM4V} />
        <Route path="/A02/ROM4P" component={ROM4P} />
        <Route path="/A02/ROM3T" component={ROM3T} />
        <Route path="/A02/ROM3V" component={ROM3V} />
        <Route path="/A02/REX3I" component={REX3I} />
      </Switch>
    </Suspense>
  );
}

export default A02;
